import { Toaster } from 'react-hot-toast'
import { AppProps } from './AppProps'

export function PageContainer({ children }: AppProps): JSX.Element {
    return (
        <div className="dark:bg-texture-dark bg-texture text-slate-800 dark:text-slate-100 min-h-screen flex flex-col">
            <Toaster />
            {children}
        </div>
    )
}
